/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import ParentEnum from 'astro/enum/parent';


export default class
{
  constructor (object, resolver)
  {
    this.object = object;
    this.resolver = resolver;
  }


  getUser ()
  {
    return this.resolver.getUser(this.object.getUserID());
  }


  getSource ()
  {
    return this.resolver.getLocation(this.object.getSource());
  }


  getTarget ()
  {
    return this.resolver.getLocation(this.object.getTarget());
  }


  getFullTarget ()
  {
    return this.getTarget().getNeighbors().getShape(this.object.getShape());
  }


  getObject ()
  {
    return this.object;
  }


}
